<template>
  <v-container
    v-show="sidebarOpen"
    id="assistant-sidebar"
    class="assistant-sidebar"
    fluid
  >
    <v-row
      class="assistant-content"
      no-gutters
    >
      <v-col
        :class="[
          'assistant-menu',
          {
            'assistant-menu--collapsed': sessionsCollapsed
          }
        ]"
        cols="auto"
      >
        <chat-menu
          :collapsed="sessionsCollapsed"
          @toggle-collapse="toggleSessionsCollapsed"
          @session-item-click="handleSessionSwitch"
          @past-activity-click="handlePastActivityClick"
          @delete-session="openDeleteDialog"
        />
      </v-col>

      <v-col
        class="assistant-chat"
        cols="auto"
      >
        <chat-panel
          :view-mode="panelView"
          class="assistant-chat-panel"
          @session-selected="handleSessionSwitch"
          @delete-session="openDeleteDialog"
        />
      </v-col>
    </v-row>

    <delete-chat-dialog
      :open="showDeleteDialog"
      @confirm="confirmDelete"
      @cancel="closeDeleteDialog"
    />
  </v-container>
</template>

<script>
import assistantService from '@/ai/services/AssistantService'
import ChatMenu from './menu/ChatMenu.vue'
import ChatPanel from './panel/ChatPanel.vue'
import DeleteChatDialog from './DeleteChatDialog.vue'

export default {
  name: 'AssistantSidebar',

  components: {
    ChatMenu,
    ChatPanel,
    DeleteChatDialog
  },

  dataStore: {
    assistantStore: 'AssistantStore'
  },

  data () {
    return {
      panelView        : 'chat',
      sessionsCollapsed: false,
      showDeleteDialog : false,
      sessionToDelete  : null
    }
  },

  computed: {
    sidebarOpen: {
      get () {
        return this.assistantStore.Sidebar.Open
      },

      set (value) {
        this.assistantStore.Sidebar.Open = value
      }
    }
  },

  methods: {
    handleSessionSwitch () {
      this.panelView = 'chat'
    },

    handlePastActivityClick () {
      this.assistantStore.SelectedSession.Data = null
      this.panelView = 'past-activity'
    },

    toggleSessionsCollapsed () {
      this.sessionsCollapsed = !this.sessionsCollapsed
    },

    openDeleteDialog (session) {
      this.sessionToDelete = session
      this.showDeleteDialog = true
    },

    closeDeleteDialog () {
      this.showDeleteDialog = false
      this.sessionToDelete = null
    },

    async confirmDelete () {
      if (!this.sessionToDelete) {
        return
      }
      try {
        const isFromRecent = this.panelView === 'chat'
        await assistantService.deleteChatSession(this.sessionToDelete.sessionId, isFromRecent)
      } finally {
        this.closeDeleteDialog()
      }
    }
  }
}
</script>

<style scoped>
.assistant-sidebar {
  position: relative;
  height: 100%;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border-radius: 20px 0 0 20px;
  padding: 0 !important;
}

.assistant-content {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background:
    radial-gradient(72% 48% at 52% 2%, rgba(227, 248, 239, 0.88) 0%, rgba(227, 248, 239, 0) 62%),
    radial-gradient(120% 95% at -8% 100%, rgba(214, 223, 248, 0.62) 0%, rgba(214, 223, 248, 0) 58%),
    radial-gradient(105% 82% at 108% -8%, rgba(230, 239, 255, 0.58) 0%, rgba(230, 239, 255, 0) 56%),
    linear-gradient(180deg, #eef2fc 0%, #e7ecfa 58%, #e7ecfa 100%);
}

.assistant-menu {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  z-index: 1;
}

.assistant-menu--collapsed {
  width: 64px !important;
  min-width: 64px !important;
}

.assistant-menu > * {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.assistant-chat {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.assistant-chat-panel {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

/* Small screens (xs) */
@media (max-width: 599px) {
  .assistant-menu {
    width: 18vw;
    min-width: 80px;
  }
  .assistant-chat {
    width: 62vw;
  }
}

/* Small screens (sm) */
@media (min-width: 600px) and (max-width: 959px) {
  .assistant-menu {
    width: 15vw;
    min-width: 120px;
  }
  .assistant-chat {
    width: 50vw;
  }
}

/* Medium screens (md) */
@media (min-width: 960px) and (max-width: 1263px) {
  .assistant-menu {
    width: 6vw;
    min-width: 140px;
  }
  .assistant-chat {
    width: 32vw;
  }
}

/* Large screens (lg) */
@media (min-width: 1264px) and (max-width: 1903px) {
  .assistant-menu {
    width: 9vw;
    min-width: 150px;
  }
  .assistant-chat {
    width: 34.5vw;
  }
}

/* Extra large screens (xl) */
@media (min-width: 1904px) {
  .assistant-menu {
    width: 9vw;
    min-width: 160px;
  }
  .assistant-chat {
    width: 33vw;
  }
}
</style>
